const turkmenTranslations = {
  dashboard: { ru: 'Дашборд', tm: 'Dolandyryş paneli' },
  hotel: { ru: 'Управление отелем', tm: 'Myhmanhanany dolandyrmak' },
  onlineBookings: { ru: 'Онлайн-брони', tm: 'Onlaýn bronlar' },
  manualBookings: { ru: 'Ручные брони', tm: 'El bilen girizilen bronlar' },
  mainNav: { ru: 'Основное', tm: 'Esasy' },
  active: { ru: 'Активные', tm: 'Işjeň' },
  notCheckedIn: { ru: 'Не заселённые', tm: 'Ýerleşmedikler' },
  canceled: { ru: 'Отменённые', tm: 'Goýbolsun edilenler' },
  refunded: { ru: 'Отменённые с возвратом', tm: 'Pul gaýtarylan ýatyrylanlar' },
  users: { ru: 'Пользователи', tm: 'Ulanyjylar' },
  siteSettings: { ru: 'Настройки сайта', tm: 'Saýtyň sazlamalary' },
  customers: { ru: 'Клиенты', tm: 'Müşderiler' },
  reviews: { ru: 'Отзывы', tm: 'Teswirler' },
  rooms: { ru: 'Номера', tm: 'Otaglar' },
  logout: { ru: 'Выйти из аккаунта', tm: 'Hasapdan çykmak' },
  activeBookingsTitle: { ru: 'Активные брони.', tm: 'Işjeň bronlar.' },
  canceledBookingsTitle: { ru: 'Отмененные брони без возврата средств.', tm: 'Pul gaýtarylmazdan ýatyrylan bronlar.' },
  refundedBookingsTitle: { ru: 'Отмененные брони с возвратом средств.', tm: 'Pul gaýtarylan ýatyrylan bronlar.' },
  manualCheckedOutTitle: { ru: 'Выселенные ручные брони.', tm: 'El bilen girizilen, myhmanlar çykyp giden bronlar.' },
  checkedInTitle: { ru: 'Заселенные брони.', tm: 'Myhmanlar ýerleşdirilen bronlar.' },
  notCheckedInTitle: { ru: 'Не заселенные брони.', tm: 'Myhmanlar ýerleşmedik bronlar.' },
  checkedIn: { ru: 'Заселенные брони', tm: 'Myhmanlar ýerleşdirilen bronlar' },
  checkedOut: { ru: 'Выселенные онлайн брони', tm: 'Myhmanlar çykyp giden onlaýn bronlar' },
  siteSection: { ru: 'УПРАВЛЕНИЕ САЙТОМ', tm: 'SAÝTY DOLANDYRMAK' },
  onlineSettingsTitle: { ru: 'Настройки онлайн-системы', tm: 'Onlaýn ulgamyň sazlamalary' },
  onlineSettingsDescription: { ru: 'Управление поиском номеров и онлайн-бронированием для клиентов', tm: 'Müşderiler üçin otag gözlegini we onlaýn bron etmegi dolandyrmak' },
  loadingStatus: { ru: 'Загрузка состояния', tm: 'Ýagdaý ýüklenýär' },
  unknownStatus: { ru: 'Состояние неизвестно', tm: 'Ýagdaý näbelli' },
  onlineEnabled: { ru: 'Система включена', tm: 'Ulgam açyk' },
  onlineDisabled: { ru: 'Система выключена', tm: 'Ulgam öçürilen' },
  onlineAvailability: { ru: 'Доступность онлайн-бронирования', tm: 'Onlaýn bron etmegiň elýeterliligi' },
  settingsDescription: { ru: 'Управление онлайн-бронированием и периодами оплаты', tm: 'Onlaýn bron etmegi we töleg döwürlerini dolandyrmak' },
  currentMode: { ru: 'ТЕКУЩИЙ РЕЖИМ', tm: 'HÄZIRKI REŽIM' },
  savedImmediately: { ru: 'Изменение применяется сразу после сохранения', tm: 'Üýtgeşme ýatda saklanandan soň güýje girýär' },
  refresh: { ru: 'Обновить', tm: 'Täzele' },
  checkingStatus: { ru: 'Проверяем состояние...', tm: 'Ýagdaý barlanýar...' },
  statusNotLoaded: { ru: 'Состояние не загружено', tm: 'Ýagdaý ýüklenmedi' },
  onlineActive: { ru: 'Онлайн-система активна', tm: 'Onlaýn ulgam işjeň' },
  maintenance: { ru: 'Ведутся технические работы', tm: 'Tehniki işler geçirilýär' },
  loadingStatusDescription: { ru: 'Получаем актуальное состояние с сервера.', tm: 'Serwerden häzirki ýagdaý alynýar.' },
  retryStatus: { ru: 'Обновите состояние и повторите попытку.', tm: 'Ýagdaýy täzeläp, täzeden synanyşyň.' },
  onlineAvailableDescription: { ru: 'Клиенты могут искать свободные номера и оформлять бронирования.', tm: 'Müşderiler boş otaglary gözläp we bron edip bilerler.' },
  onlineDisabledDescription: { ru: 'Поиск и оформление онлайн-бронирований для клиентов отключены.', tm: 'Müşderiler üçin onlaýn otag gözlegi we bron etmek öçürildi.' },
  changeNoticeTitle: { ru: 'Что изменится?', tm: 'Näme üýtgär?' },
  savingSettings: { ru: 'Сохраняем настройку...', tm: 'Sazlama ýatda saklanýar...' },
  offlineNotice: { ru: 'При выключении клиенты увидят сообщение о технических работах, а запросы поиска номеров и оплаты будут отклоняться сервером. Админка останется доступной.', tm: 'Ulgam öçürilende müşderiler tehniki işler baradaky habary görerler, otag gözlegi we töleg haýyşlary serwer tarapyndan ret ediler. Dolandyryş ulgamy elýeterli bolup galar.' },
  paymentPeriods: { ru: 'Периоды оплаты', tm: 'Töleg döwürleri' },
  periodSettingsDescription: { ru: 'Настройка сезонных правил оплаты онлайн-бронирований', tm: 'Onlaýn bronlaryň möwsümleýin töleg düzgünlerini sazlamak' },
  language: { ru: 'Язык', tm: 'Dil' },
  periodAnnualNote: { ru: 'Периоды повторяются каждый год. Если дата окончания раньше даты начала, период проходит через Новый год. Например, с 20 октября по 30 сентября.', tm: 'Döwürler her ýyl gaýtalanýar. Gutaryş senesi başlangyç senesinden öň bolsa, döwür Täze ýyl aralygyndan geçýär. Mysal üçin, 20-nji oktýabrdan 30-njy sentýabra çenli.' },
  periodsMissingWarning: { ru: 'Периоды оплаты не настроены. Онлайн-поиск и бронирование будут отклоняться для любых дат.', tm: 'Töleg döwürleri sazlanmady. Islendik seneler üçin onlaýn gözleg we bron etmek ret ediler.' },
  loadingPeriods: { ru: 'Загрузка периодов оплаты...', tm: 'Töleg döwürleri ýüklenýär...' },
  period: { ru: 'Период', tm: 'Döwür' },
  moveUp: { ru: 'Выше', tm: 'Ýokary' },
  moveDown: { ru: 'Ниже', tm: 'Aşak' },
  delete: { ru: 'Удалить', tm: 'Poz' },
  name: { ru: 'Название', tm: 'Ady' },
  startDate: { ru: 'Начало', tm: 'Başlangyjy' },
  endDate: { ru: 'Окончание', tm: 'Tamamlanmagy' },
  paymentMode: { ru: 'Что оплачивает клиент', tm: 'Müşderi näme üçin töleýär' },
  bookingOnly: { ru: 'Только бронирование', tm: 'Diňe bron üçin' },
  roomOnly: { ru: 'Только номер', tm: 'Diňe otag üçin' },
  bookingAndRoom: { ru: 'Бронирование и номер', tm: 'Bron we otag üçin' },
  noPayment: { ru: 'Без оплаты', tm: 'Tölegsiz' },
  addPeriod: { ru: 'Добавить период', tm: 'Döwür goş' },
  savePeriods: { ru: 'Сохранить периоды', tm: 'Döwürleri ýatda sakla' },
  saving: { ru: 'Сохранение...', tm: 'Ýatda saklanýar...' },
  savePaymentPeriods: { ru: 'Сохранить периоды оплаты', tm: 'Töleg döwürlerini ýatda sakla' },
  periodPriorityHint: { ru: 'При пересечении периодов применяется период, который расположен выше в списке.', tm: 'Döwürler gabat gelende sanawda ýokarda ýerleşen döwür ulanylýar.' },
  highSeasonExample: { ru: 'Например, высокий сезон', tm: 'Mysal üçin, ýokary möwsüm' },
  enableOnlineConfirm: { ru: 'Включить онлайн-бронирование для клиентов?', tm: 'Müşderiler üçin onlaýn bron etmegi açmalymy?' },
  disableOnlineConfirm: { ru: 'Выключить онлайн-бронирование? Клиенты не смогут искать и оплачивать брони.', tm: 'Onlaýn bron etmegi öçürmelimi? Müşderiler bron gözläp we töleg edip bilmezler.' },
  onlineEnabledMessage: { ru: 'Онлайн-бронирование включено', tm: 'Onlaýn bron etmek açyldy' },
  onlineDisabledMessage: { ru: 'Онлайн-бронирование выключено', tm: 'Onlaýn bron etmek öçürildi' },
  onlineToggleLabel: { ru: 'Включить или выключить онлайн-бронирование', tm: 'Onlaýn bron etmegi açmak ýa-da öçürmek' },
  january: { ru: 'Январь', tm: 'Ýanwar' },
  february: { ru: 'Февраль', tm: 'Fewral' },
  march: { ru: 'Март', tm: 'Mart' },
  april: { ru: 'Апрель', tm: 'Aprel' },
  may: { ru: 'Май', tm: 'Maý' },
  june: { ru: 'Июнь', tm: 'Iýun' },
  july: { ru: 'Июль', tm: 'Iýul' },
  august: { ru: 'Август', tm: 'Awgust' },
  september: { ru: 'Сентябрь', tm: 'Sentýabr' },
  october: { ru: 'Октябрь', tm: 'Oktýabr' },
  november: { ru: 'Ноябрь', tm: 'Noýabr' },
  december: { ru: 'Декабрь', tm: 'Dekabr' },
  statusNotFound: { ru: 'Состояние системы не найдено', tm: 'Ulgamyň ýagdaýy tapylmady' },
  loadStatusError: { ru: 'Не удалось загрузить состояние системы', tm: 'Ulgamyň ýagdaýyny ýükläp bolmady' },
  saveStatusError: { ru: 'Не удалось сохранить состояние системы', tm: 'Ulgamyň ýagdaýyny ýatda saklap bolmady' },
  invalidStatus: { ru: 'Передано некорректное состояние системы', tm: 'Ulgamyň ýagdaýy nädogry berildi' },
  statusSaved: { ru: 'Состояние системы обновлено', tm: 'Ulgamyň ýagdaýy täzelendi' },
  online: { ru: 'Онлайн', tm: 'Onlaýn' },
  bookingSearch: { ru: 'Поиск по тел/имени...', tm: 'Telefon ýa-da at boýunça gözle...' },
  roomType: { ru: 'Тип номера', tm: 'Otagyň görnüşi' },
  email: { ru: 'Почта', tm: 'E-poçta' },
  payerName: { ru: 'Имя плательщика', tm: 'Töleýjiniň ady' },
  phone: { ru: 'Тел.', tm: 'Telefon' },
  checkIn: { ru: 'Дата заезда', tm: 'Gelýän senesi' },
  checkOut: { ru: 'Дата выезда', tm: 'Gidýän senesi' },
  status: { ru: 'Статус', tm: 'Ýagdaýy' },
  totalAmount: { ru: 'Общая сумма', tm: 'Jemi möçber' },
  actions: { ru: 'Действия', tm: 'Hereketler' },
  view: { ru: 'Посмотреть', tm: 'Gör' },
  loadingData: { ru: 'Загрузка данных...', tm: 'Maglumatlar ýüklenýär...' },
  dataLoaded: { ru: 'Все данные загружены', tm: 'Ähli maglumatlar ýüklendi' },
  manualBookingsTitle: { ru: 'Активные бронирования добавленые в ручную', tm: 'El bilen girizilen işjeň bronlar' },
  add: { ru: 'Добавить', tm: 'Goş' },
  bookingNumber: { ru: 'Номер брони', tm: 'Bron belgisi' },
  documentNumber: { ru: 'Номер бланка, чека', tm: 'Blankyň ýa-da çekiň belgisi' },
  bookingType: { ru: 'Тип брони', tm: 'Bron görnüşi' },
  paymentType: { ru: 'Тип оплаты', tm: 'Töleg görnüşi' },
  createdBy: { ru: 'Создал', tm: 'Döreden' },
  totalIncome: { ru: 'Общий доход', tm: 'Jemi girdeji' },
  count: { ru: 'Количество', tm: 'Sany' },
  bookingIncome: { ru: 'Доход за бронирования', tm: 'Bronlardan gelen girdeji' },
  stayIncome: { ru: 'Доход за проживания', tm: 'Ýaşaýyşdan gelen girdeji' },
  report: { ru: 'Отчет', tm: 'Hasabat' },
  exportBookings: { ru: 'Вывести бронирования', tm: 'Bronlary çykarmak' },
  unpaidBookings: { ru: 'Не оплаченые бронирования', tm: 'Tölenmedik bronlar' },
  confirmPayment: { ru: 'Подт. оплату', tm: 'Tölegi tassyklamak' },
  usersLabel: { ru: 'Пользователи', tm: 'Ulanyjylar' },
  employee: { ru: 'Сотрудник', tm: 'Işgär' },
  manualBookingPassword: { ru: 'Пароль ручных броней', tm: 'El bronlarynyň paroly' },
  accessManagement: { ru: 'Управление доступом', tm: 'Elýeterliligi dolandyrmak' },
  accessManagementTitle: { ru: 'УПРАВЛЕНИЕ ДОСТУПОМ', tm: 'ELÝETERLILIGI DOLANDYRMAK' },
  userAccessDescription: { ru: 'Учетные записи сотрудников и их параметры доступа', tm: 'Işgärleriň hasaplary we elýeterlilik sazlamalary' },
  loadingUsers: { ru: 'Обновление списка...', tm: 'Sanaw täzelenýär...' },
  addUser: { ru: 'Добавить пользователя', tm: 'Ulanyjy goş' },
  userList: { ru: 'Список пользователей', tm: 'Ulanyjylaryň sanawy' },
  userSingular: { ru: 'пользователь', tm: 'ulanyjy' },
  userPlural: { ru: 'пользователей', tm: 'ulanyjy' },
  unnamed: { ru: 'Без имени', tm: 'Adsız' },
  password: { ru: 'Пароль', tm: 'Parol' },
  hidePassword: { ru: 'Скрыть пароль', tm: 'Paroly gizle' },
  showPassword: { ru: 'Показать пароль', tm: 'Paroly görkez' },
  save: { ru: 'Сохранить', tm: 'Ýatda sakla' },
  allUsers: { ru: 'Для всех', tm: 'Ählisi üçin' },
  cancelEdit: { ru: 'Отменить редактирование', tm: 'Redaktirlemegi ýatyr' },
  changePassword: { ru: 'Изменить пароль', tm: 'Paroly üýtget' },
  preview: { ru: 'Просмотр', tm: 'Görmek' },
  edit: { ru: 'Изменить', tm: 'Üýtget' },
  remove: { ru: 'Удалить', tm: 'Poz' },
  usersEmpty: { ru: 'Пользователи не найдены.', tm: 'Ulanyjylar tapylmady.' },
  employeeCard: { ru: 'КАРТОЧКА СОТРУДНИКА', tm: 'IŞGÄRIŇ KARTY' },
  userCardDescription: { ru: 'Информация об учетной записи и назначенной роли.', tm: 'Hasap we bellenen rol barada maglumat.' },
  username: { ru: 'Логин', tm: 'Ulanyjy ady' },
  firstName: { ru: 'Имя', tm: 'Ady' },
  role: { ru: 'Роль', tm: 'Rol' },
  close: { ru: 'Закрыть', tm: 'Ýap' },
  accessManagementTitle2: { ru: 'УПРАВЛЕНИЕ ДОСТУПОМ', tm: 'ELÝETERLILIGI DOLANDYRMAK' },
  newUserDescription: { ru: 'Создайте учетную запись сотрудника и назначьте роль.', tm: 'Işgär hasabyny dörediň we rol belläň.' },
  noRoles: { ru: 'Нет ролей', tm: 'Rollar ýok' },
  createUser: { ru: 'Создать пользователя', tm: 'Ulanyjy döret' },
  lastName: { ru: 'Фамилия', tm: 'Familiýasy' },
  oldPassword: { ru: 'Старый пароль', tm: 'Köne parol' },
  saveChanges: { ru: 'Сохранить изменения', tm: 'Üýtgeşmeleri ýatda sakla' },
  customersLabel: { ru: 'Клиенты', tm: 'Müşderiler' },
  loading: { ru: 'Загрузка...', tm: 'Ýüklenýär...' },
  emergencyAccess: { ru: 'Экстренный доступ клиента', tm: 'Müşderi üçin gyssagly giriş' },
  customerEmail: { ru: 'Email клиента', tm: 'Müşderiniň e-poçtasy' },
  passwordMinLength: { ru: 'Пароль (минимум 5 символов)', tm: 'Parol (iň azyndan 5 nyşan)' },
  processing: { ru: 'Обработка...', tm: 'Işlenýär...' },
  createOrResetAccount: { ru: 'Создать аккаунт / установить пароль', tm: 'Hasap döretmek / parol bellemek' },
  phoneNumber: { ru: 'Номер телефона', tm: 'Telefon belgisi' },
  registeredAt: { ru: 'Зарегистрировался', tm: 'Hasaba alnan senesi' },
  bookings: { ru: 'Брони', tm: 'Bronlar' },
  viewBookings: { ru: 'Просмотр броней', tm: 'Bronlary görmek' },
  customersEmpty: { ru: 'Клиенты не найдены.', tm: 'Müşderiler tapylmady.' },
  back: { ru: 'Назад', tm: 'Yza' },
  next: { ru: 'Далее', tm: 'Indiki' },
  page: { ru: 'Страница', tm: 'Sahypa' },
  bookingHistory: { ru: 'ИСТОРИЯ БРОНИРОВАНИЙ', tm: 'BRONLARYŇ TARYHY' },
  customerBookings: { ru: 'Брони клиента', tm: 'Müşderiniň bronlary' },
  loadingBookings: { ru: 'Загрузка броней...', tm: 'Bronlar ýüklenýär...' },
  noCustomerBookings: { ru: 'У клиента пока нет броней.', tm: 'Müşderiniň häzirlikçe bronlary ýok.' },
  reviewTitle: { ru: 'Отзывы', tm: 'Teswirler' },
  statusFilter: { ru: 'Фильтр по статусу:', tm: 'Ýagdaý boýunça süzgüç:' },
  all: { ru: 'Все', tm: 'Hemmesi' },
  unpublished: { ru: 'Не опубликовано', tm: 'Neşir edilmedi' },
  published: { ru: 'Опубликовано', tm: 'Neşir edildi' },
  date: { ru: 'Дата:', tm: 'Sene:' },
  reviewReply: { ru: 'Ответ на отзыв', tm: 'Teswire jogap' },
  writeReply: { ru: 'Написать ответ', tm: 'Jogap ýaz' },
  editReply: { ru: 'Изменить ответ', tm: 'Jogaby üýtget' },
  message: { ru: 'Сообщение', tm: 'Habar' },
  reply: { ru: 'Ответить', tm: 'Jogap ber' },
  reviewStatus: { ru: 'Снять с публикации', tm: 'Neşirden aýyr' },
  publish: { ru: 'Опубликовать', tm: 'Neşir et' },
  reviewDeleted: { ru: 'Отзыв удален.', tm: 'Teswir pozuldy.' },
  error: { ru: 'Ошибка', tm: 'Ýalňyşlyk' },
  roomsLabel: { ru: 'Номера', tm: 'Otaglar' },
  hiddenRoomsNote: { ru: 'Помеченные красным скрыты из общего доступа', tm: 'Gyzyl bilen bellenenler hemmeler üçin gizlenendir' },
  roomOrder: { ru: '№ порядок', tm: 'Tertip belgisi' },
  publicRooms: { ru: 'Общедоступные номера', tm: 'Hemmeler üçin elýeterli otaglar' },
  allRooms: { ru: 'Все номера', tm: 'Ähli otaglar' },
  summerPrice: { ru: 'Цена, летний сезон', tm: 'Bahasy, tomus möwsümi' },
  winterPrice: { ru: 'Цена, зимний сезон', tm: 'Bahasy, gyş möwsümi' },
  maxGuests: { ru: 'Макс. количество гостей', tm: 'Myhmanlaryň iň köp sany' },
  roomCount: { ru: 'Количество комнат в номере', tm: 'Otagdaky otaglaryň sany' },
  selectDates: { ru: 'Выберите даты', tm: 'Seneleri saýlaň' },
  showAvailableRooms: { ru: 'Показать свободные номера', tm: 'Boş otaglary görkez' },
  reset: { ru: 'Сбросить', tm: 'Arassala' },
  createBooking: { ru: 'Создать бронь', tm: 'Bron döret' },
  deleteOwnAccountError: { ru: 'Нельзя удалить свою учетную запись.', tm: 'Öz hasabyňyzy pozup bolmaýar.' },
  deleteAdminError: { ru: 'Нельзя удалить пользователя с ролью admin.', tm: 'admin roly bolan ulanyjyny pozup bolmaýar.' },
  editSameRoleError: { ru: 'Нельзя изменять пользователя с такой же ролью.', tm: 'Şol bir roldaky ulanyjyny üýtgedip bolmaýar.' },
  deleteUserConfirm: { ru: 'Вы уверены, что хотите удалить этого пользователя?', tm: 'Bu ulanyjyny pozmak isleýändigiňize ynanýarsyňyzmy?' },
  emptyPasswordError: { ru: 'Пароль не может быть пустым', tm: 'Parol boş bolup bilmez' },
  setAllPasswordsConfirm: { ru: 'Вы уверены, что хотите установить этот пароль для ВСЕХ пользователей?', tm: 'Bu paroly ÄHLI ulanyjylar üçin bellemek isleýärsiňizmi?' },
  passwordUpdatedCount: { ru: 'Пароль успешно обновлен для', tm: 'Parol şu ulanyjylar üçin üstünlikli täzelendi:' },
  passwordUpdateError: { ru: 'Произошла ошибка при обновлении паролей', tm: 'Parollary täzelemekde ýalňyşlyk ýüze çykdy' },
  deleteCustomerConfirm: { ru: 'Вы уверены, что хотите удалить этого клиента?', tm: 'Bu müşderini pozmak isleýändigiňize ynanýarsyzmy?' },
  deleteWordPrompt: { ru: 'Введите слово УДАЛИТЬ для подтверждения.', tm: 'Tassyklamak üçin УДАЛИТЬ sözüni giriziň.' },
  invalidDeleteWord: { ru: 'Не верно введено', tm: 'Nädogry girizildi' },
  deleteUserError: { ru: 'Ошибка удаления пользователя', tm: 'Ulanyjyny pozmakda ýalňyşlyk' },
  emergencyAccountConfirm: { ru: 'Создать и подтвердить аккаунт для этой почты либо заменить пароль существующего клиента?', tm: 'Bu e-poçta üçin hasap döredip tassyklamaly ýa-da bar bolan müşderiniň parolyny çalyşmalymy?' },
  emergencyAccessError: { ru: 'Не удалось выдать доступ клиенту', tm: 'Müşderä giriş hukugyny berip bolmady' },
  loadCustomerBookingsError: { ru: 'Не удалось загрузить брони клиента', tm: 'Müşderiniň bronlaryny ýükläp bolmady' },
  bookingHistoryTitle: { ru: 'ИСТОРИЯ БРОНИРОВАНИЙ', tm: 'BRONLARYŇ TARYHY' },
  deleteReviewConfirm: { ru: 'Вы уверены, что хотите удалить этот отзыв?', tm: 'Bu teswiri pozmak isleýändigiňize ynanýarsyňyzmy?' },
  reviewDeleteSuccess: { ru: 'Отзыв удален.', tm: 'Teswir pozuldy.' },
  refreshPageError: { ru: 'Ошибка, обновите страницу и попробуйте еще раз.', tm: 'Ýalňyşlyk, sahypany täzeläp täzeden synanyşyň.' },
  operationError: { ru: 'Произошла ошибка:', tm: 'Ýalňyşlyk ýüze çykdy:' },
  checkInternet: { ru: 'Проверьте соединение с интернетом', tm: 'Internet birikmesini barlaň' },
  checkServerHandler: { ru: 'Проверьте обработчик на сервере', tm: 'Serwerdäki işleýjini barlaň' },
  deleteRecordConfirm: { ru: 'Вы уверены, что хотите удалить эту запись?', tm: 'Bu ýazgyny pozmak isleýändigiňize ynanýarsyňyzmy?' },
  deleteRecordError: { ru: 'Произошла ошибка при удалении', tm: 'Pozmakda ýalňyşlyk ýüze çykdy' },
  orderUpdateError: { ru: 'Произошла ошибка при обновлении порядка', tm: 'Tertibi täzelemekde ýalňyşlyk ýüze çykdy' },
  userLabel: { ru: 'Пользователь', tm: 'Ulanyjy' },
  usernameLabel: { ru: 'Имя пользователя', tm: 'Ulanyjy ady' },
  setPassword: { ru: 'Задайте пароль', tm: 'Parol düzüň' },
  cancel: { ru: 'Отмена', tm: 'Ýatyr' },
  editUser: { ru: 'Изменить пользователя', tm: 'Ulanyjyny üýtget' },
  editUserDescription: { ru: 'Обновите данные сотрудника, роль или пароль.', tm: 'Işgäriň maglumatlaryny, roluny ýa-da parolyny täzeläň.' },
  position: { ru: 'Должность', tm: 'Wezipesi' },
  currentPasswordPrompt: { ru: 'Введите текущий пароль', tm: 'Häzirki paroly giriziň' },
  newPasswordLabel: { ru: 'Новый пароль', tm: 'Täze parol' },
  newPasswordPrompt: { ru: 'Введите новый пароль', tm: 'Täze paroly giriziň' },
  roleEditDenied: { ru: 'Свою роль изменить нельзя.', tm: 'Öz roluňyzy üýtgedip bolmaýar.' },
  roleUnset: { ru: 'Роль не установлена', tm: 'Rol bellenmedi' },
  roleAdmin: { ru: 'admin', tm: 'Administrator' },
  roleBooker: { ru: 'booker', tm: 'Bron boýunça hünärmen' },
  roleBookerAdmin: { ru: 'booker-admin', tm: 'Bron bölüminiň ýolbaşçysy' },
  roleReception: { ru: 'reception', tm: 'Resepsion' },
  userDescription: { ru: 'Учетные записи сотрудников и их параметры доступа', tm: 'Işgärleriň hasaplary we elýeterlilik sazlamalary' },
  userListLoading: { ru: 'Обновление списка...', tm: 'Sanaw täzelenýär...' },
  userNotFound: { ru: 'Пользователь не найден', tm: 'Ulanyjy tapylmady' },
  cannotDeleteOwnAccount: { ru: 'Нельзя удалить свою учетную запись.', tm: 'Öz hasabyňyzy pozup bolmaýar.' },
  cannotEditSameRole: { ru: 'Нельзя изменять пользователя с такой же ролью.', tm: 'Şol bir roldaky ulanyjyny üýtgedip bolmaýar.' },
  userLoadError: { ru: 'Не удалось загрузить пользователей.', tm: 'Ulanyjylary ýükläp bolmady.' },
  passwordUpdateErrorAlt: { ru: 'Ошибка при обновлении паролей', tm: 'Parollary täzelemekde ýalňyşlyk ýüze çykdy' },
  customerCount: { ru: 'Клиенты:', tm: 'Müşderiler:' },
  of: { ru: 'из', tm: 'içinden' },
  customerEmergencyAccess: { ru: 'Экстренный доступ клиента', tm: 'Müşderi üçin gyssagly giriş' },
  emergencyAccessDescription: { ru: 'Создаёт подтверждённый аккаунт без кода либо заменяет пароль существующего. Передайте клиенту email и заданный пароль безопасным способом.', tm: 'Kodsyz tassyklanan hasap döredýär ýa-da bar bolan hasabyň parolyny çalyşýar. Müşderä e-poçta salgysyny we paroly howpsuz usul bilen beriň.' },
  contactEmail: { ru: 'Email', tm: 'E-poçta' },
  emergencyEmail: { ru: 'Email клиента', tm: 'Müşderiniň e-poçtasy' },
  createAccount: { ru: 'Создать аккаунт / установить пароль', tm: 'Hasap döretmek / parol bellemek' },
  customerRegisteredAt: { ru: 'Зарегистрировался', tm: 'Hasaba alnan senesi' },
  customerBookingList: { ru: 'Просмотр броней', tm: 'Bronlary görmek' },
  customerBack: { ru: 'Назад', tm: 'Yza' },
  customerNext: { ru: 'Далее', tm: 'Indiki' },
  customerPage: { ru: 'Страница', tm: 'Sahypa' },
  customerBookingHistory: { ru: 'ИСТОРИЯ БРОНИРОВАНИЙ', tm: 'BRONLARYŇ TARYHY' },
  customerBookingsTitle: { ru: 'Брони клиента', tm: 'Müşderiniň bronlary' },
  customerBookingsLoading: { ru: 'Загрузка броней...', tm: 'Bronlar ýüklenýär...' },
  customerBookingsEmpty: { ru: 'У клиента пока нет броней.', tm: 'Müşderiniň häzirlikçe bronlary ýok.' },
  customerBookingNumber: { ru: 'Номер брони', tm: 'Bron belgisi' },
  customerCheckIn: { ru: 'Дата заезда', tm: 'Gelýän senesi' },
  customerCheckOut: { ru: 'Дата выезда', tm: 'Gidýän senesi' },
  customerRoomType: { ru: 'Тип номера', tm: 'Otagyň görnüşi' },
  customerBookingStatus: { ru: 'Статус', tm: 'Ýagdaýy' },
  userRoleUnset: { ru: 'Роль не установлена', tm: 'Rol bellenmedi' },
  invalidCredentials: { ru: 'Неправильный логин или пароль', tm: 'Ulanyjy ady ýa-da parol nädogry' },
  invalidPassword: { ru: 'Неправильный пароль', tm: 'Parol nädogry' },
  savedSuccessfully: { ru: 'Данные успешно сохранены', tm: 'Maglumatlar üstünlikli ýatda saklandy' },
  userCreated: { ru: 'Пользователь успешно создан', tm: 'Ulanyjy üstünlikli döredildi' },
  userUpdated: { ru: 'Пользователь успешно обновлен', tm: 'Ulanyjy üstünlikli täzelendi' },
  loadPeriodsError: { ru: 'Не удалось загрузить периоды оплаты', tm: 'Töleg döwürlerini ýükläp bolmady' },
  savePeriodsError: { ru: 'Не удалось сохранить периоды оплаты', tm: 'Töleg döwürlerini ýatda saklap bolmady' },
  periodsSaved: { ru: 'Периоды оплаты сохранены', tm: 'Töleg döwürleri ýatda saklandy' },
  addGuest: { ru: '+ Добавить гостя', tm: '+ Myhman goşmak' },
  cardDigits: { ru: '4 последние цифры банковской карты', tm: 'Bank kartynyň soňky 4 sany' },
  bankAccount: { ru: 'Anyk.belgi Кор.счет 21101934110100300007000', tm: 'Anyk.belgi Hasap 21101934110100300007000' },
  settlementAccount: { ru: 'HAS.hasaby Расчетный счет 23201934131202100045000', tm: 'HAS.hasaby Hasaplaşyk hasaby 23201934131202100045000' },
  bankCode: { ru: 'MFO(BAB) МФО 390601312', tm: 'MFO(BAB) MFO 390601312' },
  taxCode: { ru: 'Salgyt налоговый код 301111000004', tm: 'Salgyt kody 301111000004' },
  noRefund: { ru: 'Без возврата', tm: 'Pul gaýtarylmazdan' },
  form: { ru: 'Бланк', tm: 'Blank' },
  bookingsTitle: { ru: 'Бронирования', tm: 'Bronlar' },
  manualBookingsTitleAll: { ru: 'Бронирования добавленые в ручную', tm: 'El bilen girizilen bronlar' },
  booking: { ru: 'Бронь', tm: 'Bron' },
  bookingAdded: { ru: 'Бронь добавлена -', tm: 'Bron goşuldy -' },
  bookingRoomLabel: { ru: 'Бронь и номер', tm: 'Bron we otag' },
  videoUnsupported: { ru: 'Ваш браузер не поддерживает видео.', tm: 'Brauzeriňiz wideony goldamaýar.' },
  restoreBooking: { ru: 'Вернуть бронь', tm: 'Brony dikeltmek' },
  video: { ru: 'Видео', tm: 'Wideo' },
  login: { ru: 'Войти', tm: 'Girmek' },
  paymentDeadline: { ru: 'Время оплаты -', tm: 'Töleg wagty -' },
  allRoomsCount: { ru: 'Все номера (количество)', tm: 'Ähli otaglar (sany)' },
  cancellationType: { ru: 'Выберите тип отмены', tm: 'Ýatyrmagyň görnüşini saýlaň' },
  checkedOutBookingsTitle: { ru: 'Выселенные бронирования', tm: 'Myhmanlar çykyp giden bronlar' },
  exit: { ru: 'Выход', tm: 'Çykyş' },
  guestsMissing: { ru: 'Гости не указаны.', tm: 'Myhmanlar görkezilmedi.' },
  citizen: { ru: 'Гражданин', tm: 'Raýat' },
  dateTo: { ru: 'Дата до', tm: 'Şu senä çenli' },
  dateFrom: { ru: 'Дата с', tm: 'Şu seneden başlap' },
  addService: { ru: 'Добавить услугу', tm: 'Hyzmat goşmak' },
  mediaLimit: { ru: 'Добавить фото/видео (максимум 7)', tm: 'Surat/wideo goşmak (iň köp 7)' },
  paymentDue: { ru: 'Должны оплатить', tm: 'Tölemeli' },
  extraInfo: { ru: 'Дополнительная информация', tm: 'Goşmaça maglumat' },
  roomAvailability: { ru: 'Доступности номеров', tm: 'Otaglaryň elýeterliligi' },
  note: { ru: 'Заметка', tm: 'Bellik' },
  checkedInBookingsTitle: { ru: 'Заселенные бронирования', tm: 'Myhmanlar ýerleşdirilen bronlar' },
  images: { ru: 'Изображения', tm: 'Suratlar' },
  foreign: { ru: 'Иностранный', tm: 'Daşary ýurtly' },
  totalTmt: { ru: 'Итоговая сумма TMT:', tm: 'Jemi TMT:' },
  card: { ru: 'Карта', tm: 'Karta' },
  numberOfRooms: { ru: 'Количество номеров', tm: 'Otaglaryň sany' },
  bookingEndDate: { ru: 'Конечная дата:', tm: 'Tamamlanýan senesi:' },
  roomGuestCapacity: { ru: 'Максимальное количество гостей, которые могут разместиться в номере', tm: 'Otagda ýerleşip biljek myhmanlaryň iň köp sany' },
  maxDaysAhead: { ru: 'Максимум дней от сегодняшнего дня', tm: 'Şu günden başlap iň köp gün sany' },
  minDaysAhead: { ru: 'Минимум дней от сегодняшнего дня', tm: 'Şu günden başlap iň az gün sany' },
  cash: { ru: 'Наличные', tm: 'Nagt pul' },
  bookingStart: { ru: 'Начало брони', tm: 'Bronuň başlanýan wagty' },
  bookingStartDate: { ru: 'Начальная дата:', tm: 'Başlangyç senesi:' },
  notSelected: { ru: 'Не выбрано', tm: 'Saýlanmady' },
  uncheckedBookingsTitle: { ru: 'Не заселенные бронирования', tm: 'Myhmanlar ýerleşmedik bronlar' },
  unpaid: { ru: 'Не оплаченые', tm: 'Tölenmedik' },
  doNotCancel: { ru: 'Не отменять', tm: 'Ýatyrmaň' },
  noRooms: { ru: 'Нет номеров', tm: 'Otag ýok' },
  newBooking: { ru: 'Новая бронь', tm: 'Täze bron' },
  newItems: { ru: 'Новые', tm: 'Täzeler' },
  newRoomType: { ru: 'Новый тип номера', tm: 'Otagyň täze görnüşi' },
  room: { ru: 'Номер', tm: 'Otag' },
  formNumber: { ru: 'Номер бланка', tm: 'Blankyň belgisi' },
  paymentReference: { ru: 'Номер бланка, чека или терминала', tm: 'Blankyň, çekiň ýa-da terminalyň belgisi' },
  checkNumber: { ru: 'Номер чека', tm: 'Çekiň belgisi' },
  bookingTotal: { ru: 'Общая сумма брони:', tm: 'Bronuň umumy bahasy:' },
  extraGuestsTotal: { ru: 'Общая сумма за доп. гостей:', tm: 'Goşmaça myhmanlar üçin umumy baha:' },
  roomTotalUsd: { ru: 'Общая сумма за номер $:', tm: 'Otag üçin umumy baha $:' },
  roomTotalTmt: { ru: 'Общая сумма за номер TMT:', tm: 'Otag üçin umumy baha TMT:' },
  publicRoomsCount: { ru: 'Общедоступные номера (количество)', tm: 'Umumy elýeterli otaglar (sany)' },
  bookingEnd: { ru: 'Окончание брони', tm: 'Bronuň tamamlanýan wagty' },
  description: { ru: 'Описание', tm: 'Beýany' },
  payment: { ru: 'Оплата:', tm: 'Töleg:' },
  paid: { ru: 'Оплаченые', tm: 'Tölenen' },
  awaitingPayment: { ru: 'Отдано на оплату -', tm: 'Tölege iberildi -' },
  canceledBookingsAllTitle: { ru: 'Отмененные бронирования', tm: 'Ýatyrylan bronlar' },
  canceledUnrefundedTitle: { ru: 'Отмененные бронирования без возврата средств', tm: 'Pul gaýtarylmazdan ýatyrylan bronlar' },
  canceledRefundedTitle: { ru: 'Отмененные бронирования с возвратом средств', tm: 'Pul gaýtarylyp ýatyrylan bronlar' },
  canceledStatus: { ru: 'Отменено', tm: 'Ýatyryldy' },
  cancelAction: { ru: 'Отменить', tm: 'Ýatyrmak' },
  cancelBooking: { ru: 'Отменить бронь', tm: 'Brony ýatyrmak' },
  confirmCancelBooking: { ru: 'Отменить бронь?', tm: 'Brony ýatyrmalymy?' },
  sendUserData: { ru: 'Отправить данные пользователю', tm: 'Ulanyja maglumat ibermek' },
  sendByEmail: { ru: 'Отправить по почте', tm: 'E-poçta arkaly ibermek' },
  bookingReport: { ru: 'Отчет бронирований', tm: 'Bronlar hasabaty' },
  transfer: { ru: 'Перечисление', tm: 'Geçirim' },
  bankTransfer: { ru: 'Перечислением', tm: 'Geçirim arkaly' },
  print: { ru: 'Печать', tm: 'Çap etmek' },
  printCost: { ru: 'Печать стоит', tm: 'Çap etmegiň bahasy' },
  payerIsNotGuest: { ru: 'Плательщик не является гостем', tm: 'Töleýji myhman däl' },
  payer: { ru: 'Плательщик:', tm: 'Töleýji:' },
  byDates: { ru: 'По датам', tm: 'Seneler boýunça' },
  byDays: { ru: 'По дням', tm: 'Günler boýunça' },
  confirmPaymentFull: { ru: 'Подтвердить оплату', tm: 'Tölegi tassyklamak' },
  confirmed: { ru: 'Подтвержденные', tm: 'Tassyklanan' },
  show: { ru: 'Показать', tm: 'Görkez' },
  toggleRoomType: { ru: 'Показать/скрыть тип номера', tm: 'Otagyň görnüşini görkezmek/gizlemek' },
  payerFullName: { ru: 'Полное имя плательщика', tm: 'Töleýjiniň doly ady' },
  getReport: { ru: 'Получить отчет', tm: 'Hasabaty almak' },
  user: { ru: 'Пользователь:', tm: 'Ulanyjy:' },
  placeBooking: { ru: 'Поставить бронь', tm: 'Bron goýmak' },
  applyStamp: { ru: 'Поставить печать', tm: 'Möhür basmak' },
  check: { ru: 'Проверить', tm: 'Barlamak' },
  editingTitle: { ru: 'Редактирование', tm: 'Üýtgetmek' },
  russian: { ru: 'Русский', tm: 'Rusça' },
  withRefund: { ru: 'С возвратом', tm: 'Pul gaýtarylyp' },
  passportSerial: { ru: 'Серийный номер паспорта', tm: 'Pasportyň seriýa belgisi' },
  hide: { ru: 'Скрыть', tm: 'Gizle' },
  saveStatus: { ru: 'Сохранить статус', tm: 'Ýagdaýy ýatda saklamak' },
  paymentLink: { ru: 'Ссылка для оплаты', tm: 'Töleg salgysy' },
  paymentStatus: { ru: 'Статус оплаты', tm: 'Töleg ýagdaýy' },
  bankStatus: { ru: 'Статус от банка', tm: 'Bankyň ýagdaýy' },
  fullPhone: { ru: 'Телефон', tm: 'Telefon' },
  type: { ru: 'Тип', tm: 'Görnüşi' },
  bookingTypeLabel: { ru: 'Тип бронирования', tm: 'Bronuň görnüşi' },
  availabilityType: { ru: 'Тип доступности номера', tm: 'Otagyň elýeterlilik görnüşi' },
  paymentTypeLabel: { ru: 'Тип оплаты:', tm: 'Töleg görnüşi:' },
  availabilityTypes: { ru: 'Типы доступности номеров', tm: 'Otaglaryň elýeterlilik görnüşleri' },
  turkmenistan: { ru: 'Туркменистана', tm: 'Türkmenistan' },
  removeGuest: { ru: 'Удалить гостя', tm: 'Myhmany aýyrmak' },
  services: { ru: 'Услуги', tm: 'Hyzmatlar' },
  photos: { ru: 'Фотографии', tm: 'Suratlar' },
  receipt: { ru: 'Чек', tm: 'Çek' },
  byCheck: { ru: 'Чеком', tm: 'Çek arkaly' },
  unpaidStatus: { ru: 'без оплаты', tm: 'tölegsiz' },
  roomLowercase: { ru: 'номер', tm: 'otag' },
  guestAdd: { ru: 'Добавить гостя', tm: 'Myhman goşmak' },
  successfulLogin: { ru: 'Авторизация успешна', tm: 'Ulgama üstünlikli girildi' },
  loginError: { ru: 'Ошибка авторизации', tm: 'Ulgama girip bolmady' },
  formNumberAuto: { ru: 'Автоматически выборе бланка', tm: 'Blanky awtomatik saýlaň' },
  checkNumberAuto: { ru: 'Автоматически выборе чека', tm: 'Çegi awtomatik saýlaň' },
  phonePrompt: { ru: 'Введите номер тел.', tm: 'Telefon belgisini giriziň' },
  emailPrompt: { ru: 'Введите почту', tm: 'E-poçta salgysyny giriziň' },
  checkOutPrompt: { ru: 'Выезд', tm: 'Çykyş senesi' },
  checkInPrompt: { ru: 'Заезд', tm: 'Giriş senesi' },
  fullNamePrompt: { ru: 'Имя Фамилия', tm: 'Ady Familiýasy' },
  notePrompt: { ru: 'Напишите заметку', tm: 'Bellik ýazyň' },
  mainNavigation: { ru: 'Основная навигация', tm: 'Esasy nawigasiýa' },
  appearsAfterPayment: { ru: 'Появится при оплате', tm: 'Tölegden soň peýda bolar' },
  row: { ru: 'Строка', tm: 'Setir' },
  text: { ru: 'Текст', tm: 'Tekst' },
  amenity: { ru: 'Удобство', tm: 'Amatlylyk' },
  number: { ru: 'Число', tm: 'San' },
  unpaidLabel: { ru: 'Не оплачено.', tm: 'Tölenmedi.' },
  paidAt: { ru: 'Оплачено', tm: 'Tölenildi' },
  unavailablePrice: { ru: 'Цена не доступна', tm: 'Bahasy elýeterli däl' },
  roomNotSelected: { ru: 'Номер не выбран', tm: 'Otag saýlanmady' },
  formSuffix: { ru: 'бланка', tm: 'blankyň' },
  checkSuffix: { ru: 'чека', tm: 'çegiň' },
  afterSaving: { ru: 'Появится после сохранения', tm: 'Ýatda saklanandan soň peýda bolar' },
  month: { ru: 'месяц', tm: 'aý' },
  day: { ru: 'день', tm: 'gün' },
  departed: { ru: 'Выселен', tm: 'Myhman çykyp gitdi' },
  arrived: { ru: 'Заселён', tm: 'Myhman ýerleşdirildi' },
  paidBooking: { ru: 'Оплачена', tm: 'Tölenen' },
  waitingPayment: { ru: 'Ожидает оплаты', tm: 'Tölege garaşýar' },
  noName: { ru: 'Имя не указано', tm: 'Ady görkezilmedi' },
  unassigned: { ru: 'не назначен', tm: 'bellenmedi' },
  noRoomSelected: { ru: 'Номер не выбран', tm: 'Otag saýlanmady' },
  loadSealFirst: { ru: 'Сначала загрузите печать', tm: 'Ilki bilen möhüri ýükläň' },
  linkCopied: { ru: 'Ссылка скопирована!', tm: 'Salgy göçürildi!' },
  saveDataError: { ru: 'Произошла ошибка при сохранении данных.', tm: 'Maglumatlary ýatda saklamakda ýalňyşlyk ýüze çykdy.' },
  selectBothDates: { ru: 'Пожалуйста, выберите обе даты!', tm: 'Iki senäni hem saýlaň!' },
  noBookingsForPeriod: { ru: 'Нет бронирований за выбранный период.', tm: 'Saýlanan döwürde bron ýok.' },
  availabilityUpdated: { ru: 'Доступность обновлена', tm: 'Elýeterlilik täzelendi' },
  availabilityUpdateError: { ru: 'Произошла ошибка при обновлении доступности', tm: 'Elýeterliligi täzelemekde ýalňyşlyk ýüze çykdy' },
  availabilityAdded: { ru: 'Доступность добавлена', tm: 'Elýeterlilik goşuldy' },
  availabilityAddError: { ru: 'Произошла ошибка при добавлении доступности', tm: 'Elýeterliligi goşmakda ýalňyşlyk ýüze çykdy' },
  availabilityDeleted: { ru: 'Доступность удалена', tm: 'Elýeterlilik aýryldy' },
  availabilityDeleteError: { ru: 'Произошла ошибка при удалении доступности', tm: 'Elýeterliligi aýyrmakda ýalňyşlyk ýüze çykdy' },
  deleteFileError: { ru: 'Произошла ошибка при удалении файла', tm: 'Faýly aýyrmakda ýalňyşlyk ýüze çykdy' },
  reorderFailed: { ru: 'Произошла ошибка при обновлении порядка', tm: 'Tertibi täzelemekde ýalňyşlyk ýüze çykdy' },
  reportError: { ru: 'Произошла ошибка при получении отчета.', tm: 'Hasabaty almakda ýalňyşlyk ýüze çykdy.' },
  reviewSendError: { ru: 'Произошла ошибка:\n1. Проверьте соединение с интернетом\n2. Проверьте обработчик на сервере', tm: 'Ýalňyşlyk ýüze çykdy:\n1. Internet birikmesini barlaň\n2. Serwer işleýşini barlaň' },
  incorrectDeleteWord: { ru: "Не верно введено 'УДАЛИТЬ'", tm: "'УДАЛИТЬ' sözi nädogry girizildi" },
  deleteItemPrompt: { ru: 'Вы уверены, что хотите удалить', tm: 'Aýyrmak isleýärsiňizmi' },
  deleteClientError: { ru: 'Не верно введено', tm: 'Nädogry girizildi' },
  printLoadedReport: { ru: 'Нет бронирований', tm: 'Bron ýok' },
  availabilityPeriodDates: { ru: 'По датам', tm: 'Seneler boýunça' },
  availabilityPeriodDays: { ru: 'По дням', tm: 'Günler boýunça' },
  cancelPayment: { ru: 'Отменить оплату', tm: 'Tölegi ýatyrmak' },
  addPaymentConfirm: { ru: 'Подтвердить оплату', tm: 'Tölegi tassyklamak' },
  videoLower: { ru: 'видео', tm: 'wideony' },
  picture: { ru: 'картинку', tm: 'suraty' },
  fullNameNumber: { ru: 'Полное имя #', tm: 'Doly ady #' },
  orderStatus: { ru: 'Статус заказа:', tm: 'Sargyt ýagdaýy:' },
  guestFullName: { ru: 'Полное имя гостя', tm: 'Myhmanyň doly ady' },
  createdByPrefix: { ru: 'Создал:', tm: 'Döreden:' },
  yes: { ru: 'Да', tm: 'Hawa' },
  no: { ru: 'Нет', tm: 'Ýok' },
  bookingPaymentReportBefore: { ru: 'Отчет бронирований об оплате за', tm: 'Şu senedäki bron tölegleriniň hasabaty:' },
  bookingPaymentReportRange: { ru: 'Отчет бронирований об оплате за период', tm: 'Döwür boýunça bron tölegleriniň hasabaty:' },
  numberRoomPrefix: { ru: 'Номер комнаты:', tm: 'Otag belgisi:' },
  checkInPrefix: { ru: 'Заезд:', tm: 'Giriş:' },
  checkOutPrefix: { ru: 'Выезд:', tm: 'Çykyş:' },
  bookingCreatedPrefix: { ru: 'Заявка создана:', tm: 'Arza döredildi:' },
  paidPrefix: { ru: 'Оплачено:', tm: 'Töleg geçirildi:' },
  guests: { ru: 'Гости', tm: 'Myhmanlar' },
  passportPrefix: { ru: 'Паспорт:', tm: 'Pasport:' },
  passwordPrefix: { ru: 'Пароль:', tm: 'Parol:' },
  sending: { ru: 'Отправка...', tm: 'Iberilýär...' },
  enterEmailToSend: { ru: 'Укажите email для отправки', tm: 'Ibermek üçin e-poçta salgysyny giriziň' },
  employeeDataUnavailable: { ru: 'Не удалось загрузить данные сотрудника для печати', tm: 'Çap etmek üçin işgär maglumatlaryny ýükläp bolmady' },
  documentGenerationError: { ru: 'Не удалось сформировать документ для отправки', tm: 'Ibermek üçin resminamany taýýarlap bolmady' },
  generatingDocument: { ru: 'Формирование и отправка документа...', tm: 'Resminama taýýarlanylýar we iberilýär...' },
  documentSendError: { ru: 'Не удалось отправить документ', tm: 'Resminamany iberip bolmady' },
  receiptSent: { ru: 'Чек отправлен на почту', tm: 'Çek e-poçta arkaly iberildi' },
  emailNotSpecified: { ru: 'Email не указан', tm: 'E-poçta salgysy görkezilmedi' },
  invalidEmail: { ru: 'Некорректный email', tm: 'E-poçta salgysy nädogry' },
  bookingNotFound: { ru: 'Бронирование не найдено', tm: 'Bron tapylmady' },
};

export const translateAdmin = (text, language) => {
  const entry = Object.values(turkmenTranslations).find((translation) => translation.ru === text);
  const selectedLanguage = language || (
    typeof localStorage !== 'undefined' && localStorage.getItem('adminLanguage') === 'tm' ? 'tm' : 'ru'
  );
  return entry?.[selectedLanguage] || text;
};
